function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.144 137.144",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 137.144 137.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m80.144,27.429c-7.644,0-11.911,1.809-15.804,5.429-3.894,3.618-2.625,9.81-2.625,15.143v13.715h-13.714v13.714h13.715v34.286h13.714v-34.287h10.286l3.429-13.714h-13.716v-6.858c0-2.285 0.079-1.404 0-6.857-0.075-4.893 2.963-6.857 5.679-6.857h5.464l2.572-12.952v-0.334c-0.929-0.126-1.286-0.11-3.215-0.239-1.928-0.125-3.857-0.189-5.785-0.189zm29.571-27.429h-82.286c-15.149,0-27.429,12.28-27.429,27.429v82.287c0,15.148 12.28,27.429 27.429,27.429h82.286c15.148,0 27.429-12.28 27.429-27.429v-82.287c0-15.149-12.28-27.429-27.429-27.429zm13.715,102.858c0,11.361-9.21,20.572-20.571,20.572h-68.573c-11.361,0-20.572-9.211-20.572-20.572v-68.572c0-11.362 9.21-20.572 20.572-20.572h68.572c11.361,0 20.571,9.21 20.571,20.572v68.572z",
    id: "id_103",
    style: {
      fill: "rgb(245, 249, 250)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5b68fd9202d8a1f572e3d560faf53ce1.svg";
export { ForwardRef as ReactComponent };